import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import AppPaths from '../../../../AppPaths';
import styles from './FreeTrialBlocker.module.scss';

interface FreeTrialBlockerProps {
  onlyFreeTrials: boolean;
  onRemoveFreeTrial: () => void;
}

export default function FreeTrialBlocker({ onlyFreeTrials, onRemoveFreeTrial }: FreeTrialBlockerProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h3 className={styles.title}>{t('free_trial_blocker_title')}</h3>
        <p className={styles.description}>{t('free_trial_blocker_description')}</p>
        <div className={styles.actions}>
          {onlyFreeTrials ? (
            <Link to={AppPaths.Home} className={styles.secondaryLink} onClick={onRemoveFreeTrial}>
              {t('free_trial_blocker_back_to_shop')}
            </Link>
          ) : (
            <>
              <button type="button" className={styles.removeButton} onClick={onRemoveFreeTrial}>
                {t('free_trial_blocker_remove_and_continue')}
              </button>
              <Link to={AppPaths.Bag} className={styles.secondaryLink}>
                {t('edit_cart')}
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
